import {
  Box,
  Button,
  CloseButton,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Skeleton,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { mdiMagnify } from '@mdi/js';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { OrganizationAccessField } from 'features/user-groups/components/CreateTeamDrawer/components/OrganizationAccessField';
import { useDrawerStateDispatch } from 'features/main/context';
import { openDrawer } from 'features/main/context/drawer/actionCreators';
import { useGroupData } from 'features/user-group/user-group-details/hooks/useGroupData';
import { OrgGroupApps } from 'features/user-group/user-group-tabs/components/OrgGroupApps';

export const GroupConfigurationTab = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [, drawerDispatch] = useDrawerStateDispatch();
  const { id: groupId } = useParams<{ id: string }>();

  const { tenantList, orgGroupLoading } = useGroupData(groupId);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchInputValue = event.target.value;
    setSearchValue(searchInputValue);
  };

  const onClearHandler = () => {
    setSearchValue('');
  };

  return (
    <>
      <HStack mb='6'>
        <Box width='sm' data-testid='group-org-access-box'>
          <Skeleton isLoaded={true}>
            <OrganizationAccessField boldText />
          </Skeleton>
        </Box>
      </HStack>
      <HStack>
        <Box width='sm' data-testid='group-apps-search-box'>
          <Text mb='4' fontWeight='bold'>
            App Access
          </Text>
          <Skeleton isLoaded={true}>
            <InputGroup mb='4' maxWidth='sm'>
              <InputLeftElement
                pointerEvents='none'
                children={
                  <Icon>
                    <path d={mdiMagnify} />
                  </Icon>
                }
              />
              <Input
                data-testid='group-apps-search-input'
                value={searchValue}
                onChange={onChangeHandler}
                placeholder='Search apps'
              />
              {searchValue.length > 0 && (
                <InputRightElement>
                  <Tooltip label='Clear search'>
                    <CloseButton
                      onClick={onClearHandler}
                      data-testid='group-apps-search-clear-button'
                    />
                  </Tooltip>
                </InputRightElement>
              )}
            </InputGroup>
          </Skeleton>
        </Box>
      </HStack>
      <HStack mb='6'>
        <Box width='2xl' data-testid='group-apps-config-box'>
          <Skeleton isLoaded={!orgGroupLoading}>
            <OrgGroupApps
              isLoading={orgGroupLoading}
              tenantList={tenantList}
              searchValue={searchValue}
            />
            <Button
              type='button'
              variant='outline'
              size='md'
              onClick={() =>
                drawerDispatch(
                  openDrawer('add-apps-drawer', { tenantList, groupId }),
                )
              }
              my='4'
              data-testid='group-add-product-button'
            >
              Add app
            </Button>
          </Skeleton>
        </Box>
      </HStack>
    </>
  );
};
